/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-left-16[_ngcontent-%COMP%]{padding-left:16px}.padding-right-16[_ngcontent-%COMP%]{padding-right:16px}.width-270[_ngcontent-%COMP%]{width:270px}.ng-select.custom[_ngcontent-%COMP%]     .ng-select-container .ng-value-container{max-height:80px;overflow:scroll;overflow-x:hidden}\n/*# sourceMappingURL=view-campaigns.component.css.map*/"];
export { styles as styles };
